export default __webpack_public_path__ + "static/media/growingman.5a254822.jpg";